// MultiplicadoresSelecionados.tsx
import React from 'react';

interface Registro {
  id?: number | undefined;
  descricao: string;
  multiplicador: number | undefined; 
}

interface MultiplicadoresSelecionadosProps {
  registrosSelecionados: Registro[];
}

const MultiplicadoresSelecionados: React.FC<MultiplicadoresSelecionadosProps> = ({ registrosSelecionados }) => {
    const totalMultiplicador = registrosSelecionados.reduce((acc, registro) => {
        const valor = registro.multiplicador || 0; // Converte para número, tratando valores nulos ou undefined
        return acc + valor;
      }, 0); // 0 é o valor inicial do acumulador
  return (
    <div className="mt-6 w-full max-w-2xl bg-white rounded-lg shadow p-4">
      <h2 className="text-xl font-bold mb-4">Multiplicadores Selecionados</h2>
      <ul>
        
          <li className="flex justify-between mb-2">
            <span className="font-bold">Total</span>
            <span className="font-bold">{totalMultiplicador}</span>
          </li>
      </ul>
    </div>
  );
};

export default MultiplicadoresSelecionados;
